import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { AppLayoutComponent } from './layout/app-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'endkunden',
        loadChildren: () =>
          import('./features/endkunden/endkunden.routes').then((m) => m.endkundenRoutes),
      },
      {
        path: 'artikel',
        loadChildren: () =>
          import('./features/artikel/artikel.routes').then((m) => m.artikelRoutes),
      },
      {
        path: 'bestaende',
        loadChildren: () =>
          import('./features/bestaende/bestaende.routes').then((m) => m.bestaendeRoutes),
      },
      {
        path: 'artikelbewegungen',
        loadChildren: () =>
          import('./features/artikelbewegungen/artikelbewegungen.routes').then((m) => m.artikelbewegungenRoutes),
      },
    ],
  },
];
